import { ThreadView } from "@/app/Threads/Components/ThreadView";
import { workOrderMessageThreadRoute } from "@/app/ProDrivers/Common/Routes/proDriverRoutes";

export function WorkOrderMessageThreadScreen() {
  const { threadId } = workOrderMessageThreadRoute.useParams();

  return <ThreadView key={threadId} id={threadId} />;
}
